

//*************************DO NOT MODIFY**************************
//
//THESE FILES ARE AUTOGENERATED WITH TYPEWRITER AND ANY MODIFICATIONS MADE HERE WILL BE LOST
//PLEASE VISIT http://frhagn.github.io/Typewriter/ TO LEARN MORE ABOUT THIS VISUAL STUDIO EXTENSION
//
//*************************DO NOT MODIFY**************************
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { UtilisateurAngular } from '../models/UtilisateurAngular';
import { StringViewModel } from '../models/StringViewModel';
import { LoginViewModel } from '../models/LoginViewModel';

@Injectable({
   providedIn: 'root'
})
export class AccountApiService {
    constructor(private _httpClient: HttpClient) { }        
    
    // get: api/Account/getUtilisateurInfo
    getUtilisateurInfo(): Observable<UtilisateurAngular> {
        var _Url = `api/Account/getUtilisateurInfo`;
            return this._httpClient.get<UtilisateurAngular>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/Account/getCheckInfo?id=${id}
    getCheckInfo(id: number): Observable<StringViewModel> {
        var _Url = `api/Account/getCheckInfo?id=${id}`;
            return this._httpClient.get<StringViewModel>(_Url).pipe(catchError(this.handleError));
    }
    
    // post: api/Account/login
    login(loginModel: LoginViewModel): Observable<UtilisateurAngular> {
        var _Url = `api/Account/login`;
            return this._httpClient.post<UtilisateurAngular>(_Url, loginModel).pipe(catchError(this.handleError));
    }
    
    // Utility
    private handleError(error: HttpErrorResponse) {
        console.error(error);
        let customError: string = "";
        if (error.error) {
            customError = error.status === 400 ? error.error : error.statusText
        }
        return throwError(customError || 'Server error');
    }
}
